import { Box, IconButton, Stack, Tooltip } from "@mzc-pdc/ui";
import { NotifyCommentItem } from "./notify-comment-item";
import theme from "@styles/theme";
import { alpha } from "@mui/material";
import { useCallback, useMemo, useRef } from "react";
import { IconCircle } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";
import { NOTIFY_TYPES } from "@constants";

export const NotifyItem = ({ item, onClickToggleReadButton, onClickClose }) => {
    const { t } = useTranslation();
    const contentRef = useRef(null);

    const isUnread = useMemo(() => item?.status === "UNREAD", [item]);
    const notifyType = useMemo(() => item?.data?.type, [item]);

    const onHandleClickItem = useCallback(
        (item) => {
            if (isUnread) {
                onClickToggleReadButton?.(item);
            }
            onClickClose?.();
        },
        [onClickToggleReadButton, onClickClose, isUnread],
    );

    const handleStackClick = useCallback(() => {
        contentRef.current?.handleClick?.();

        onHandleClickItem(item);
    }, [item, onHandleClickItem]);

    const NotifyContentComponent = useMemo(() => {
        if (NOTIFY_TYPES?.COMMENTS?.includes(notifyType)) {
            return NotifyCommentItem;
        }

        // 추후 다른 타입 추가 시 여기에 조건 추가
        // if (type === "OTHER_TYPE") {
        //     return NotifyOtherTypeItem;
        // }

        return null;
    }, [notifyType]);

    return (
        <Stack
            component="button"
            direction="row"
            onClick={handleStackClick}
            sx={{
                width: "100%",
                gap: theme.spacing(1.5),
                p: theme.spacing(2.5),
                cursor: "pointer",
                borderBottom: `1px solid ${theme.palette.greySecondary[100]}`,
                "&:hover": {
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.24),
                    ".btn-toggle-read": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    },
                },
                "&:active": {
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.36),
                },

                ".btn-toggle-read:active": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.12),
                },
            }}
        >
            <Box sx={{ flex: 1 }}>
                {NotifyContentComponent && <NotifyContentComponent ref={contentRef} item={item} />}
            </Box>
            <Box sx={{ flexShrink: 0, flexBasis: "20px", display: "flex", alignItems: "center" }}>
                <Tooltip
                    title={t(
                        `common::label::${isUnread ? "Mark as read" : "Mark as unread"}`,
                        isUnread ? "Mark as read" : "Mark as unread",
                    )}
                >
                    <IconButton
                        className={"btn-toggle-read"}
                        circled
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickToggleReadButton?.(item);
                        }}
                    >
                        {isUnread && <IconCircle size={12} htmlColor={theme.palette.primary.main} />}
                    </IconButton>
                </Tooltip>
            </Box>
        </Stack>
    );
};
